module.exports = __webpack_public_path__ + "img/habilitada.eaa4f073.gif";